
import ProdUnitCmp from '~/components/ug/ProdUnitCmp.vue' // 상품유닛
export default {
  name: 'ProdSwiper',
  components: {
    ProdUnitCmp
  },
  props: {
    swiperType: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => {
        return {
          navigation: false,
          pagination: false
        }
      }
    },
    swiperData: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    tabIndicator: {
      type: Array,
      default: () => {
        return ['1~10위', '11~20위']
      }
    },
    oneLine: { // 23.08.24 추가
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      swiperOpt: { // swiper options
        slidesPerView: 1,
        loop: false,
        lazy: true,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="blind">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span>/</span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        threshold: 30,
        watchOverflow: true, // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
        slidesPerColumn: 1,
        slidesPerGroup: 1
        // grid: {
        //   rows: 2
        // }
        // slidesPerColumnFill: 'column'
      }
    }
  },
  computed: {
    // swiper () {
    //   return this.$refs.prodSwipe.swiper
    // }
  },
  watch: {
  },
  created () {
    // 자동롤링
    if (typeof (this.options.auto) === 'number') {
      this.swiperOpt.autoplay = {
        delay: this.options.auto,
        disableOnInteraction: false
      }
    }

    // 무한루프
    if (this.options.loop === true) {
      this.swiperOpt.loop = this.options.loop
    }

    // 인디케이터
    if (this.options.pagination === 'fraction') {
      this.swiperOpt.pagination.type = this.options.pagination
    } else if (this.options.pagination === 'tab') {
      const tabInd = this.tabIndicator
      this.swiperOpt.pagination = {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets', // 버튼 디자인 bullets" / "fraction"
        renderBullet (index, className) {
          return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="">' + tabInd[index] + '</span></button>'
        }
      }
    }

    // slidesPerView
    if (this.options.slidesPerView !== undefined) {
      this.swiperOpt.slidesPerView = this.options.slidesPerView
    }

    // slidesPerColumn
    if (typeof this.options.slidesPerColumn === 'number') {
      this.swiperOpt.slidesPerColumn = this.options.slidesPerColumn
    }

    // slidesPerGroup
    if (typeof this.options.slidesPerGroup === 'number') {
      this.swiperOpt.slidesPerGroup = this.options.slidesPerGroup
    }
  },
  mounted () {
  },
  unmounted () {
  },
  methods: {
  }
}
